import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a date string in "YYYY-MM-DD" format to a Date object without timezone shift
 * This prevents dates from showing as one day earlier due to UTC interpretation
 * @param {string} dateStr - Date string in "YYYY-MM-DD" format
 * @returns {Date} Date object representing the local date
 */
export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
